import { FC, useEffect, useState } from 'react'
import './Addons.css'

interface PageIndicatorProps {
  currentPage: number
  totalPages: number
  shouldShow: boolean
  setShouldShow: (value: boolean) => void
}

export const PageIndicator: FC<PageIndicatorProps> = ({
  currentPage,
  totalPages,
  shouldShow,
  setShouldShow,
}) => {
  const [isPageIndicatorVisible, setIsPageIndicatorVisible] = useState(false)
  const [pageIndicatorTimeout, setPageIndicatorTimeout] = useState<NodeJS.Timeout>()

  const handlePageIndicatorVisibility = () => {
    setShouldShow(false)
    setIsPageIndicatorVisible(true)
    //kill timeout
    if (pageIndicatorTimeout) {
      clearTimeout(pageIndicatorTimeout)
    }
    setIsPageIndicatorVisible(true)

    setPageIndicatorTimeout(
      setTimeout(() => {
        setIsPageIndicatorVisible(false)
      }, 2000)
    )
  }

  useEffect(() => {
    if (shouldShow) {
      handlePageIndicatorVisibility()
    }
  }, [shouldShow])

  return (
    <>
      {isPageIndicatorVisible && (
        <div className="pdf-addons__page-number-indicator">
          {currentPage} / {totalPages}
        </div>
      )}
    </>
  )
}
